import { forwardRef } from 'react';
/** Used for form input groups, like CheckboxGroup etc.
 *  adds the GROUP true attribute and casts, to prevent
 *  the need to do this for the components themselves.
 *  plain forwardRef doesn't let you add custom static props
 *  to a component. */
export function forwardRefForInputGroup(render) {
    var returnComp = forwardRef(render);
    returnComp.GROUP = true;
    return returnComp;
}
//# sourceMappingURL=forwardInputGroupRef.js.map